module.exports = __webpack_public_path__ + "img/column_202509-2.f002a1ca.jpg";